// Palette CIL – design coerente
export const CIL = {
  yellow: '#ffcc00',
  teal: '#3eb297',
  sky: '#36a9e1',
  pink: '#e95995',
  plum: '#3b235a',
  red: '#e73341',
  yellowLight: '#fff5cc',
  tealLight: 'rgba(62, 178, 151, 0.15)',
  skyLight: 'rgba(54, 169, 225, 0.15)',
  plumLight: 'rgba(59, 35, 90, 0.12)',
  pinkLight: 'rgba(233, 89, 149, 0.12)',
};

// Colori per GradientText (titoli sezioni) – inizio/fine uguali per loop fluido (blu palette al posto del giallo)
export const CIL_GRADIENT_COLORS = [
  CIL.plum,
  CIL.pink,
  CIL.sky,
  CIL.teal,
  CIL.sky,
  CIL.plum,
];

/** Sfondo gradiente radiale per i contenitori dei titoli di sezione (bianco al centro, blu palette ai bordi) */
export const SECTION_TITLE_CONTAINER_BG =
  'radial-gradient(circle at 50% 50%, #ffffff 0%, rgba(54, 169, 225, 0.35) 50%, #36a9e1 100%)';

/** Colore testo titoli di sezione (neutro, senza animazione) */
export const SECTION_TITLE_TEXT_COLOR = 'gray.800';

// Hero
export const VIDEO_URL = '/videos/ce-2026-hero.mp4';
export const HERO_TITLE = 'Centro Estivo 2026';
export const HERO_SUBTITLE = '7 settimane di gioco, creatività e amicizia';
export const PRIMARY_CTA_LABEL = 'Prenota il posto';
export const HERO_KEY_LINE =
  '15 Giugno – 4 Agosto · 6–14 anni · 120€ a settimana';

// Informazioni essenziali (6 card)
export const INFO_QUANDO_TITLE = 'Quando';
export const INFO_QUANDO_BODY = [
  '15 Giugno – 4 Settembre 2026',
  'Dal lunedì al venerdì',
  '8:00 – 17:00',
  '(copertura 8–18)',
];
export const INFO_ETA_TITLE = 'Età';
export const INFO_ETA_BODY = [
  'Dalla prima elementare alla prima superiore',
  'Gruppi suddivisi per età in base al tipo di attività.',
];
export const INFO_PREZZO_TITLE = 'Prezzo';
export const INFO_PREZZO_BODY = [
  '120€ a settimana',
  '100€ fratelli',
  '100€ pacchetto MVP',
  'Acconto & Saldo disponibili.',
];
export const INFO_PRANZO_TITLE = 'Pranzo';
export const INFO_PRANZO_BODY = [
  'Pranzo al sacco',
  'Pasto convenzionato (5€)',
  'Frigo + microonde disponibili.',
];
// Sezione Pasti – collaborazione Nascondiglio, recensioni da questionario
export const PASTI_INTRO =
  'In collaborazione con il Nascondiglio di Chieri possiamo offrire pasti che possono essere prenotati giorno per giorno al costo di 5€. Puoi ordinarli entro le 9:30 del giorno stesso.';
export const PASTI_REVIEWS = [
  {
    text: 'Pasto comodo e puntuale. A volte avrei preferito più varietà nel menù.',
    stars: 3,
    maxStars: 5,
    source: 'Questionario 2025',
  },
  {
    text: 'Servizio ottimo, una cosa in meno a cui pensare. Lo riprendiamo anche il prossimo anno.',
    stars: 5,
    maxStars: 5,
    source: 'Questionario 2025',
  },
];

export const INFO_DOVE_TITLE = 'Dove';
export const INFO_DOVE_BODY = [
  'Munlab',
  'Cambiano (TO)',
  'Spazi verdi + aree coperte',
];

// Quick Info (legacy / fallback)
export const QUICK_INFO_INTRO_TITLE = 'Informazioni essenziali';
export const QUICK_INFO_INTRO_TEXT =
  "Tutte le informazioni pratiche in un colpo d'occhio.";
export const LOCATION = 'Munlab – Cambiano (TO)';
export const DATE_RANGE = '15 Giugno – 4 Settembre 2026';
export const AGE_RANGE = 'Prima elementare – Prima superiore';
export const BASE_PRICE = '120€ a settimana';

// Pricing fallbacks (when event not loaded)
export const WEEK_PRICE = 120;
export const SIBLING_PRICE = 100;
export const MVP_PRICE = 700;

// Experience – path o URL immagini (i componenti possono usare import da src/images)
export const IMG_EXP_1 = ''; // ce-2025-1.jpg o URL
export const IMG_EXP_2 = ''; // ce-2025-2.jpg o URL
export const IMG_EXP_3 = ''; // ce-2025-3.jpg o URL
export const IMG_EXP_4 = ''; // ce-2025-4.jpg o URL
export const VIDEO_EXPERIENCE = '';

// Team
export const TEAM_COUNT = 6;
export const COORDINATOR_NAME = '';
export const TEAM_IMAGES = [];

// Animatori – una card per ogni animatore (ProfileCard)
export const ANIMATORI = [
  {
    id: '1',
    name: 'Anna Rossi',
    title: 'Educatrice',
    handle: 'anna.r',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=anna',
    contactText: 'Profilo',
  },
  {
    id: '2',
    name: 'Marco Bianchi',
    title: 'Educatore',
    handle: 'marco.b',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=marco',
    contactText: 'Profilo',
  },
  {
    id: '3',
    name: 'Laura Verdi',
    title: 'Educatrice',
    handle: 'laura.v',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=laura',
    contactText: 'Profilo',
  },
  {
    id: '4',
    name: 'Giuseppe Neri',
    title: 'Educatore',
    handle: 'giuseppe.n',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=giuseppe',
    contactText: 'Profilo',
  },
  {
    id: '5',
    name: 'Elena Russo',
    title: 'Educatrice',
    handle: 'elena.r',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=elena',
    contactText: 'Profilo',
  },
  {
    id: '6',
    name: 'Luca Ferraro',
    title: 'Educatore',
    handle: 'luca.f',
    status: 'Centro Estivo',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/png?seed=luca',
    contactText: 'Profilo',
  },
];

// Location – path o URL (componente può usare ce-2025-munlab.jpg)
export const LOCATION_IMAGE = '';
export const LOCATION_DESCRIPTION =
  'Via Camporelle 50, Cambiano (TO) – area verde con spazi coperti, ideale anche in caso di maltempo.';

// Stats 2025 (big typography) – dati allineati al CIL Wrapped 2025 dove applicabile
export const CHILDREN_2025 = 60;
export const PROFESSIONALS_2025 = 13;
export const ACTIVITY_HOURS = 360;
export const WEEKS_SOLD_OUT = 90;
// Recap 2025 – dati da questionario 2025
export const ISCRIZIONI_TOTALI_2025 = 495;
export const ORE_ANIMATORI_2025 = 2700;
export const PCTO_ATTIVATI_2025 = 2;
export const STATS_2025_LABELS = {
  children: 'bambini a settimana',
  soldOut: 'settimane sold out',
  hours: 'ore di attività',
  ghiaccioli: 'ghiaccioli distribuiti',
  consiglierebbe: 'delle famiglie lo consiglierebbe',
  pagamentiElettronici: 'pagamenti elettronici',
  iscrizioniTotali: 'iscrizioni totali',
  oreAnimatori: 'ore di animatori attivi',
  animatoreOgni10: 'animatore ogni 10 bambini',
  famiglieSoddisfatte: 'famiglie soddisfatte',
  ragazziTornare: 'ragazzi vogliono tornare',
  pctoAttivati: 'percorsi di PCTO attivati',
};

/** Valore aggiunto sotto ogni dato del Recap 2025 */
export const STATS_2025_VALUE_ADD = {
  ghiaccioli: 'il fresco momento del venerdì',
  pagamentiElettronici: 'fiducia nel sito e pagamenti sicuri',
  iscrizioniTotali: 'comunità che cresce con noi',
  oreAnimatori: 'Senza contare la programmazione!',
  animatoreOgni10: 'rapporto qualità che fa la differenza',
  famiglieSoddisfatte: 'la vostra soddisfazione è il nostro obiettivo',
  ragazziTornare: "l'esperienza che lascia il segno",
  pctoAttivati: 'formazione e inclusione nel territorio',
};

// Sezione YouTube – player unico con elenco (id, title, short)
export const YOUTUBE_VIDEOS = [
  { id: 'rlYoZKlMTsU', title: 'Primitivi', short: false },
  { id: '7uc7MUu99cw', title: 'Recap 2025', short: true },
  { id: 'DpQK5U3ku_g', title: 'Volare', short: false },
  { id: '8EZFs_svQHs', title: 'Ogni feedback è un buon feedback', short: true },
];

// Sticky CTA mobile – diretto e concreto per il genitore
export const STICKY_CTA_LABEL = 'Prenota il posto';

// Gallery (placeholder arrays)
export const GALLERY_IMAGES = [];
export const GALLERY_VIDEOS = [];

// Testimonianze Centro Estivo
export const TESTIMONIALS = [
  {
    text: 'È il centro estivo più bello del mondo! Mi mancherete tantissimo!',
    author: 'Partecipante, 9 anni',
  },
  { text: "Vorrei che durasse tutto l'anno!", author: 'Partecipante' },
  {
    text: 'Animatori super coinvolgenti, attenti e capaci di ascoltare davvero i ragazzi.',
    author: 'Genitore',
  },
  {
    text: 'Il gioco libero in radura è stata la parte più bella della giornata!',
    author: 'Partecipante',
  },
  {
    text: 'Un ambiente stimolante, creativo e pieno di energia positiva.',
    author: 'Genitore',
  },
  {
    text: 'Mi sono sentito sempre ascoltato quando avevo bisogno.',
    author: 'Partecipante',
  },
  {
    text: 'Temi originali, laboratori ben organizzati e staff davvero competente.',
    author: 'Genitore',
  },
  {
    text: 'Mio figlio è sempre tornato a casa felice e sereno. Per noi questo vale tutto.',
    author: 'Genitore',
  },
  {
    text: 'Professionalità, empatia e una bellissima atmosfera di gruppo.',
    author: 'Genitore',
  },
  {
    text: 'Il venerdì finale è stato emozionante e divertentissimo!',
    author: 'Partecipante',
  },
];

// Timeline della giornata (Centro Estivo) – infografica sintetica + contenuto per tab desktop
// sectionBg: placeholder sfondo per ogni sezione (da sostituire con immagini/grafiche definitive)
export const DAY_TIMELINE = [
  {
    time: '8:00 – 9:00',
    title: 'Accoglienza',
    description: '',
    detail:
      'I bambini vengono accolti dagli animatori in un momento di passaggio sereno tra famiglia e centro estivo. Controllo presenze, breve giro di presentazione e avvio della giornata!.',
    sectionBg:
      'linear-gradient(135deg, rgba(54, 169, 225, 0.12) 0%, rgba(54, 169, 225, 0.35) 100%)',
    sectionImageKey: 'accoglienza',
  },
  {
    time: '9:00 – 10:30',
    title: 'Attività',
    description: '',
    detail:
      'Laboratori e attività legate al tema della settimana: creatività, scienza, natura, teatro. I gruppi sono organizzati per fascia d’età con proposte adatte a ciascuno.',
    sectionBg:
      'linear-gradient(135deg, rgba(62, 178, 151, 0.15) 0%, rgba(62, 178, 151, 0.08) 100%)',
    sectionImageKey: 'attivita_930',
  },
  {
    time: '10:30',
    title: 'Merenda',
    description: '',
    detail:
      'Pausa merenda per ricaricarsi prima della seconda parte della mattinata. Momento di condivisione e relax tra i bambini.',
    sectionBg:
      'linear-gradient(135deg, rgba(255, 180, 100, 0.15) 0%, rgba(255, 220, 180, 0.35) 100%)',
  },
  {
    time: '11:00 – 12:30',
    title: 'Attività',
    description: '',
    detail:
      'Proseguono le attività tematiche della mattina: laboratori, giochi di gruppo e proposte creative fino all’ora del pranzo.',
    sectionBg:
      'linear-gradient(135deg, rgba(54, 169, 225, 0.12) 0%, rgba(144, 205, 244, 0.25) 100%)',
    sectionImageKey: 'attivita_11',
  },
  {
    time: '12:30',
    title: 'Canto',
    description: '',
    detail:
      'Momento di canto condiviso con tutto il gruppo prima del pranzo: un rituale che unisce e dà il via alla pausa di mezzogiorno.',
    sectionBg:
      'linear-gradient(135deg, rgba(255, 180, 100, 0.15) 0%, rgba(255, 220, 180, 0.35) 100%)',
    sectionImageKey: 'canto',
  },
  {
    time: '12:45 – 13:30',
    title: 'Pranzo',
    description: '',
    detail:
      'Pranzo al sacco portato da casa oppure pasto convenzionato (5€). Sono disponibili frigorifero e microonde. Tavoli per età.',
    sectionBg:
      'linear-gradient(135deg, rgba(255, 180, 100, 0.15) 0%, rgba(255, 220, 180, 0.35) 100%)',
    sectionImageKey: 'pranzo',
  },
  {
    time: '13:30 – 15:00',
    title: 'Giochi tranquilli e film',
    description: '',
    detail:
      'Dopo pranzo, spazio per giochi tranquilli e un pezzo di film: ne vediamo una parte ogni giorno dal lunedì al venerdì per diluirne la visione nella settimana. Momento di relax e calma prima delle attività pomeridiane.',
    sectionBg:
      'linear-gradient(135deg, rgba(59, 35, 90, 0.1) 0%, rgba(233, 89, 149, 0.1) 100%)',
    sectionImageKey: 'backstage', // usa Backstage.00_01_32_07.Immagine006.jpg come sfondo e immagine sezione
  },
  {
    time: '15:00 – 16:30',
    title: 'Attività',
    description: '',
    detail:
      'Pomeriggio dedicato ad attività e laboratori: costruzioni, pittura, giochi d’acqua quando fa caldo, esplorazioni nel verde del Munlab.',
    sectionBg:
      'linear-gradient(135deg, rgba(62, 178, 151, 0.15) 0%, rgba(62, 178, 151, 0.08) 100%)',
    sectionImageKey: 'attivita_15',
  },
  {
    time: '16:30',
    title: 'Merenda',
    description: '',
    detail:
      'Seconda merenda della giornata: momento di pausa prima dell’uscita, per ritrovare le energie e prepararsi al ritiro.',
    sectionBg:
      'linear-gradient(135deg, rgba(255, 180, 100, 0.15) 0%, rgba(255, 220, 180, 0.35) 100%)',
    sectionImageKey: 'merenda_1630',
  },
  {
    time: '17:00 – 18:00',
    title: 'Uscita',
    description: '',
    detail:
      'Rientro graduale e ritiro da parte dei genitori. Gli Animatori sono disponibili per un breve scambio su come è andata la giornata.',
    sectionBg:
      'linear-gradient(135deg, rgba(54, 169, 225, 0.08) 0%, rgba(59, 35, 90, 0.06) 100%)',
    sectionImageKey: 'uscita',
  },
];

// Card sotto la giornata tipo: merenda condivisa, pranzo club grandi, momento conclusivo venerdì
export const GIORNATA_TIPO_CARDS = [
  {
    title: 'Merenda condivisa (gruppo piccoli)',
    detail:
      'Il mercoledì viene chiesto alle famiglie di portare una merenda da condividere con tutti: un momento di condivisione per i più piccoli.',
  },
  {
    title: 'Pranzo condiviso per il Club dei grandi',
    detail:
      'Il giovedì si organizza un pranzo condiviso dove ognuno porta qualcosa da condividere. Questa attività sostituisce il pranzo del giorno.',
  },
  {
    title: 'Momento conclusivo ore 16:30 del venerdì',
    detail:
      'Il venerdì alle 16:30 aspettiamo i genitori per una breve restituzione partecipata e un piccolo rinfresco per salutarci e chiudere insieme la settimana.',
  },
];

// Date delle 7 settimane Centro Estivo 2026
export const SETTIMANE_2026 = [
  {
    id: 1,
    label: 'Settimana 1',
    dataInizio: '2026-06-15',
    dataFine: '2026-06-19',
    dateLabel: '15–19 giugno 2026',
  },
  {
    id: 2,
    label: 'Settimana 2',
    dataInizio: '2026-06-22',
    dataFine: '2026-06-26',
    dateLabel: '22–26 giugno 2026',
  },
  {
    id: 3,
    label: 'Settimana 3',
    dataInizio: '2026-06-29',
    dataFine: '2026-07-03',
    dateLabel: '29 giugno – 3 luglio 2026',
  },
  {
    id: 4,
    label: 'Settimana 4',
    dataInizio: '2026-07-06',
    dataFine: '2026-07-10',
    dateLabel: '6–10 luglio 2026',
  },
  {
    id: 5,
    label: 'Settimana 5',
    dataInizio: '2026-07-13',
    dataFine: '2026-07-17',
    dateLabel: '13–17 luglio 2026',
  },
  {
    id: 6,
    label: 'Settimana 6',
    dataInizio: '2026-07-20',
    dataFine: '2026-07-24',
    dateLabel: '20–24 luglio 2026',
  },
  {
    id: 7,
    label: 'Settimana 7',
    dataInizio: '2026-07-27',
    dataFine: '2026-08-04',
    dateLabel: '27 luglio – 4 agosto 2026',
  },
];
